import React, { useCallback, useMemo } from 'react';
import { LegalIssuesForm } from '../../../../../../components/LoiForm/LegalIssuesForm';
import { LoiForm } from '../../../../../../slices/marketplace/loi-form/loi-form';
import { LoiFormMode } from '../../../../../../slices/marketplace/loi-form/loi-form-mode.enum';
import { LegalIssueItem } from '../../../../../../slices/marketplace/loi-form/legal-issue-item';
import { TimelineActionType } from '../../../../../../slices/marketplace/timeline/models/timeline-action-type.model';
import './AdditionalNdaCovenants.scss';

interface AdditionalNdaCovenantsProps {
    formData: LoiForm;
    isReadonly: boolean;
    onChange: (additionalCovenants: LegalIssueItem[]) => void;
    invalidItemIds?: Set<string>;
    actionType?: TimelineActionType;
}

export const AdditionalNdaCovenants = (props: AdditionalNdaCovenantsProps) => {
    const additionalCovenants = props.formData.additionalCovenants ?? [];
    const additionalCovenantSections = useMemo(
        () =>
            (props.formData?.legalIssueSections ?? []).filter((s) =>
                additionalCovenants.some((ac) => ac.sectionId === s.id)
            ),
        [props.formData?.legalIssueSections, additionalCovenants]
    );

    const handleChange = useCallback((payload: LoiForm) => {
        props.onChange(payload.legalIssues ?? []);
    }, [props.onChange]);

    if (props.actionType === TimelineActionType.BuyerLoiSubmission) {
        return (
            <div className="additional-nda-covenants-body">
                <div className="loi-tab-not-available">Not yet available.</div>
            </div>
        );
    }

    return (
        <div className="additional-nda-covenants-body">
            <LegalIssuesForm
                legalIssueSections={additionalCovenantSections}
                legalIssues={additionalCovenants}
                termForm={props.formData.termForm}
                onChange={handleChange}
                mode={LoiFormMode.BuyerProfile}
                readOnly={props.isReadonly}
                invalidItemIds={props.invalidItemIds}
            />
        </div>
    );
};
